const formattedCardExpiries = (initValue) => {
  const month = initValue.slice(0, 2);
  const year = initValue.slice(-2);

  return `${month}/${year}`;
};

export default formattedCardExpiries;
